import { useForm } from 'react-hook-form';
import { EmailCheckFormFieldsModel } from '../../../models/EmailCheckFormFieldsModel';
import React, { FunctionComponent, useCallback, useContext } from 'react';
import { FormContext } from '../../../store/MLI/MLIContext';
import { Office } from '../../../utils';
import { API } from '../../../services';
import { formItems } from './form-items';
import { ValidationModel } from '../../../models/ValidationModel';
import { StepperContent } from '../../shared/Stepper';
import { Text } from '../../shared/Text';
import { OfficeSelector } from '../../shared/OfficeSelector';
import { Input } from '../../shared/Input';
import { Grid } from '../../shared/Grid';
import { Column } from '../../shared/Column';
import { isValidEmail, isValidPhoneNumber } from '../../../utils/validations';
import { Button } from '../../shared/Button';
import { EmailCheckResponseModel } from '../../../models';

interface EmailCheckProps {
  handleEmailCheck: (state: EmailCheckResponseModel, formData: EmailCheckFormFieldsModel) => void;
}
export const EmailCheck: FunctionComponent<EmailCheckProps> = ( { handleEmailCheck }) => {
  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors, isValid}
  } = useForm<EmailCheckFormFieldsModel>({
    mode: 'onChange'
  });

  const { setIsLoading } = useContext(FormContext);
  const setOfficeValue = useCallback((office: Office | null) => {
    if (!office) return;
    setValue('office', office, { shouldValidate: true });
  }, [setValue]);




  const scrollToStepper = () => {
    const stepper = document.querySelector<HTMLDivElement>('.c-stepper');

    if (stepper) {
      window.scrollTo({
        top: stepper.offsetTop,
        behavior: 'smooth',
      });
    }
  };


  const onSubmit = (data: EmailCheckFormFieldsModel) => {
    if (!data.office) {
      if (window.confirm('Er is iets mis gegaan, probeer het opnieuw. Blijft dit probleem zich voordoen, neem dan contact op met info@hypotheker.nl.')){
        window.location.reload();
      }
      return;
    }
    setIsLoading({ state: true, message: 'We zijn je gegevens aan het verwerken'});
    API.get<EmailCheckResponseModel>(`clientcommunication/emailcheck?Email=${data.email}&OfficeId=${data.office.officeId}`)
      .then((response) => {
        handleEmailCheck(response, data);
        scrollToStepper();
      })
      .finally(() => setIsLoading({ state: false, message: ''}))
      .catch((error: ValidationModel) => {
        console.table(error);
      });
  };


  return (
    <>
      <div className="u-padding-top--md u-padding-bottom--md">
        <StepperContent>
          <div>
            <Text as="h3">Zoek een vestiging bij jou in de buurt</Text>
            <OfficeSelector
              setValue={setOfficeValue}
            />
            <Input
              name={formItems.office}
              id={formItems.office}
              register={register}
              hasError={errors.office}
              type="hidden"
              validation={{required: true}}
            />
          </div>
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Text as="h3">Jouw gegevens</Text>
              <div>
                <Grid>
                  <Column cols={[6, null, null, 4]}>
                    <Input
                      label="Voorletters *"
                      name={formItems.name}
                      id={formItems.name}
                      register={register}
                      hasError={errors.name}
                      validation={{required: true}}
                    />
                    {errors.name && (
                      <span className="form__error">Dit veld is verplicht</span>
                    )}
                  </Column>
                  <Column cols={[6, null, null, 3]}>
                    <Input
                      label="Tussenvoegsel"
                      name={formItems.addition}
                      id={formItems.addition}
                      register={register}
                      hasError={errors.tussenvoegsel}
                    />
                  </Column>
                  <Column cols={[12, null, null, 5]}>
                    <Input
                      label="Achternaam *"
                      name={formItems.lastname}
                      id={formItems.lastname}
                      register={register}
                      hasError={errors.lastname}
                      validation={{required: true}}
                    />
                    {errors.lastname && (
                      <span className="form__error">Dit veld is verplicht</span>
                    )}
                  </Column>
                </Grid>
              </div>
              <div>
                <Input
                  label="Telefoonnummer*"
                  name={formItems.phoneNumber}
                  id={formItems.phoneNumber}
                  register={register}
                  hasError={errors.phoneNumber}
                  type="tel"
                  validation={{required: true, validate: isValidPhoneNumber}}
                />
                {errors.phoneNumber && (
                  <span className="form__error">
                                Vul een tien-cijferig telefoonnummer in (voorbeeld: 06-12345678 of
                                010-1234567)
                            </span>
                )}
              </div>

              <div>
                <Input
                  label="E-mailadres*"
                  name={formItems.email}
                  id={formItems.email}
                  register={register}
                  hasError={errors.email}
                  type="email"
                  validation={{required: true, validate: isValidEmail}}
                />
                {errors.email && (
                  <span className="form__error">
                                Vul een correct e-mailadres in (bijv. user@domain.com)
                            </span>
                )}
              </div>
              <Button label="Verder" disabled={!isValid} />

            </form>
          </div>

        </StepperContent>
      </div>
    </>
  );
};
